<xemex-dialog-shell [title]="'devices.closeStatusDialog.title' | translate">
  <div class="p-2">
    <span>{{
      'devices.closeStatusDialog.message' | translate: { statusName: data.statusName }
    }}</span>
    @if (data.resetsDeviceLog) {
      <p>{{ 'devices.closeStatusDialog.resetWarning' | translate }}</p>
    }
  </div>
  <mat-dialog-actions actions>
    <button mat-flat-button (click)="onConfirm()" color="warn">
      {{ 'general.btnConfirm' | translate }}
    </button>
    <button mat-stroked-button mat-dialog-close type="button">
      {{ 'general.btnCancel' | translate }}
    </button>
  </mat-dialog-actions>
</xemex-dialog-shell>
